import { observer } from "mobx-react-lite";
import ChannelsList from "@menu/components/shared/channels-list";
import { DisplayItem } from "@menu/core/menu.context";
import { ContextProps } from "@menu/core/types";

const MobileChannels = observer((props: ContextProps) => {
    const { context } = props;

    if (!context.displayChannelMenu || context.channels.length <= 0) {
        return null;
    }

    const onBack = () => {
        context.updateDisplayItem(DisplayItem.MainNav);
    }

    return (
        <nav className="mobile-channels">
            <p className="mobile-back" onClick={onBack}>
                <i className="icon-arrow-long-left_4px" />
                {context.dictionary.browseSites}
            </p>

            <p>
                {context.dictionary.externalSitesTitle}
            </p>

            <ChannelsList context={context} className="mobile-channels" />
        </nav>
    );
});

export default MobileChannels;